import React from 'react';
import { I18n } from 'react-redux-i18n';

const InputText = (props) => {
  const {
    title, ariaDescription, value, fatherStateName, handleText,
  } = props;

  return (
    <div className="form-group form-promotion-picker">
      <p className="margin-bottom-2">{I18n.t(title)}</p>
      <div className="inputs">
        <input
          className="form-control"
          type="text"
          placeholder=""
          aria-describedby={ariaDescription}
          value={value}
          onChange={event => handleText(event.target.value, fatherStateName)}
        />
      </div>
    </div>
  );
};

export default InputText;
